import { Component } from '@angular/core';
import { URLSearchParams } from "@angular/http";
import { IonicPage, NavController, NavParams, Events, AlertController, LoadingController, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceProvider } from './../../providers/api-service/api-service';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  user: FormGroup;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private apiServiceProvider: ApiServiceProvider,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private events: Events
  ) {
    this.user = this.formBuilder.group({
      mail: ['', Validators.required],
      password: ['', Validators.required]
    });
  
    // JPUCのシステムから呼び出された場合、自動ログイン処理を行う
    let params:any = new URLSearchParams(decodeURIComponent(window.location.search.slice(1)));
    let request:any = {};
    params.paramsMap.forEach((value:any, key:any) => {
      console.log(key + ' = ' + value);
      request[key] = value[0];
    });
    console.log(request);
    
    // このデータがあればAPIで自動でユーザを作成し、ログインするようにする
    if (request.jpucUserId && request.jpucOfficeId) {
      this.autoLogin(request)
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }

  private timeout(sec:number = 10) {
    return new Promise((resolve:any) => {
      setTimeout(() => resolve(true), sec*1000);
    })
  }

  async autoLogin(request) {
    let loading = this.loadingCtrl.create({content: "自動ログイン中..."});
    loading.present();

    await this.timeout(2);

    this.user.patchValue({
      mail: request.email,
      password: '',
    });

    this.apiServiceProvider.loginJPUC(request).then((res:any) => {
      console.log(res);
      let toast = this.toastCtrl.create({
        message: `${res.data.name}さん ようこそ！`,
        duration: 3000,
        position: 'top'
      });
      toast.present();

      // セキュリティ上URLを書き換えておく
      history.replaceState('','','/');

      window.sessionStorage.setItem('user', JSON.stringify(res.data));
      if (res.data.isAdminOffice) {
        this.onSignInAdmin();
      } else {
        this.onSignInNormal();
      }

      loading.dismiss();
    }).catch(e => {
      loading.dismiss();
      alert('自動ログインに失敗しました');

      this.user = this.formBuilder.group({
        mail: ['', Validators.required],
        password: ['', Validators.required]
      });

      this.user.patchValue({
        mail: '',
        password: '',
      });
    })
  }

  onSignIn() {
    let showErrorMessage = false;
    this.apiServiceProvider.signIn(this.user.value, showErrorMessage).then((res:any) => {
      let toast = this.toastCtrl.create({
        message: `${res.data.name}さん ようこそ！`,
        duration: 3000,
        position: 'top'
      });
      toast.present();

      window.sessionStorage.setItem('user', JSON.stringify(res.data));
      if (res.data.isAdminOffice) {
        this.onSignInAdmin();
      } else {
        this.onSignInNormal();
      }
    }).catch((error:any) => {
      this.onSignInError(error);

    });
  }

  onSignInError(error: any) {
    console.error(error);
    let alert= this.alertCtrl.create({title: 'ログインエラー', message: 'ログイン失敗しました', buttons: ['OK']});
    alert.present();

    this.user.patchValue({
      mail: '',
      password: '',
    });

  }

  onSignInNormal() {
    let user:any = JSON.parse(window.sessionStorage.getItem('user'));
    if (user) {
      // 一般企業の中でもroleでadminとuserにわかれる（メニューが違うのみ)
      if (user.role === 'admin') {
        this.events.publish('changeMenu', 'userAdmin');
      } else {
        this.events.publish('changeMenu', 'user');
      }
    }
    this.navCtrl.setRoot('TopPage');
  }


  onSignInAdmin() {
    this.events.publish('changeMenu', 'superAdmin');
    this.navCtrl.setRoot('AdminContentsPage');
  }


}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts